import parse from 'html-react-parser';
import React from 'react';
import { subjectTypes } from '../../@types/entities/subjects.entity';
import Board from '../../assets/icons/board';
import { Container, Content, ContentBox, Title, WrapIcon } from './styles';

export type INextClass = {
  title: string | null;
  content: string;
  subject: subjectTypes | string;
};

const BACKGROUND_CONTAINER_THEME = 50;
const COLOR_THEME = 10;

export default function NextClass({ title, content, subject }: INextClass) {
  return (
    <Container $color={BACKGROUND_CONTAINER_THEME} $subject={subject}>
      <ContentBox>
        <Title $color={COLOR_THEME} $subject={subject}>
          <WrapIcon $color={COLOR_THEME} $subject={subject}>
            <Board />
          </WrapIcon>
          {title ? <h6>{title}</h6> : null}
        </Title>
        <Content>{parse(content)}</Content>
      </ContentBox>
    </Container>
  );
}
